<template>
  <div class="wrapper">
    <div class="content">
      <div class="container-title"><div class="container-title-text">速派服务协议</div> <span class="container-title-close" @click="closeContainer">×</span></div>
      <div class="container">
        <div class="carrier">
          <div class="title">《FASTGO快件承运条款》</div>
          基本条款 <br>
          寄件人：指在所在地国家委托FASTGO(速派）寄运物品进境中国（大陆）的个人或单位。<br>
          承运人：指FASTGO(速派）,负责物品的运输及淸关。<br>
          收件人：指在中国境内收取寄件人委托承运人所寄送包裹的个人或单位<br>
          1、寄件人委托承运人寄往各地之文件、货物、包裹及运送有关之物品，悉依本承运条款办理。寄件人委托前请先详细阅读本条款，全部了解后再填写快递单办理一切承运手续，一经填写即当作接受本条款内容。
          2.相关法律、法规禁止寄送的物品，承运人不予收寄。包括但不限于：有价票证、禁寄的刊物、文物、金银制品、护照、私人证件、批文、现金、动物、植物、药物、毒品、仿制物品、有腐蚀性或放射性等危险、易燃易爆品及一切有关法律禁止邮寄的物品。寄件人应确保托寄物不属于禁寄物品。详情请参考官网“包装指南和禁寄物品"https://www.fastgo.com.au/<br>
          3.每个包裹单边长度超过40CM,起计费重量的计算公式为：体积重量=长X宽X高/5000。以上计算公式中，长、宽、高的单位为厘米。<br>
          4.当寄件人将物品交付给承运人时，承运人有权力对所收取的运送物件包裏打开并查验。国际包裹的海关通关规定寄件人必通提交海关通关所所属的文件，寄件人应确保所有有关物品的声明和信息都是真实的，和正确的。<br>
          5.在海关淸关过程中，或由于寄件人/收件人未能提供正确的文件、资料，或未能取得必要的许可证或批文，因而产生的海关罚款、储存费用和/或其它费用均由收件人负担，同时还须缴纳相应的附加费和税款。寄件人应当对收件人未付上述费用承担赉任。寄件人应当了解错误和欺诈的陈述或申报将可能受到民事和刑事处罚，包括对货品的没收、拍卖、销毀、迟运等。<br>
          6.总价值超过人民币1000.00元以上的包裹不能收寄：保健品、洗护用品包裹毛重不超过3.5公斤；化妆品包包裹不超过1公斤；如申报价值低于市场价请提供发票。旧物品不能收寄。或承运人与寄件人另行商定包裏的货值、重量限制，及附件条軟。
          保价条款<br>
          1.保价费率为申明价值的3%,保价须随快递面单附上发票原件，保价的货品、金额必须与发票信息一致。<br>
          2.如没有保价，则每票丢件理赔标准为：提供购物发票，按照发累面額理赔，但最高理赔不超过200.00元所在地货市；未能提供购物发票，则按照毎公斤20.00元所在地货币理赔，但最高理赔不超过200.00元所在地货币。<br>
          3.保价覆盖的递送范因并不涵盖从代收点/取件点到FASTGO仓库这段距离，只涵盖从FASTGO快递仓库到指定目的地的范围。<br>
          4.由于所在国海关开箱查验异致包装不严实而造成的后续运输破损，不在保价范畴，理赔参照第2条执行。<br>
          5.破损的主张必须提供快递派件员的签字证明与照片，内件丢失必须在快递派件员见证下清点货物并得到快递派件员的签字认可。物品的包装必须符合“FASTGOT快递包装指南”，详情请参考官网“包装指南和禁寄物品”https://www.fastgo.com.au/,其破损理赔要求才可以得到主张。<br>
          6.婴儿奶粉破损的责任
          婴儿奶粉必须按FASTGO速派的包装要求进行包装，对于其它不适规定包装的破损，FASTGO速派没有赔偿责任。婴儿奶粉如果在承运过程中出现损坏，如发生变型憋罐雄但不影响食用的，不给以描偿。如果发生泄露或爆管，对于可瑞康、爱他美、贝拉米、A2的铁罐装以外的婴儿奶粉，不予以赔偿。对于可瑞康、爱他美、见拉米、A2的铁罐装奶粉，按发票金额给予赔偿。1)需提供发票原件，如没有发票原件，按FASTGO认定的市场价格给与赔偿或进行实物赔付。2)其它条款参照前述条款执行。免责条款对托运货件的毁损，不论本公司是否知悉或应知悉可能发生该毁损，不论是直接、间接、特殊或衍生的损失，包括但不限于收入或利润损失，本公司对超过本“承运条款”、我司快件赔偿责任（详情参考官网“快件赔偿”https://www.fastgo.com.au/),以及相关法律法规规定的限度不负责任。对本公司无法控制之事件所造成之损失、损毁或延误，本公司不负任何责任。<br>
          本服务条款解释权归FastGo速派快递公司所有。<br>
        </div>
        <div class="carrier">
          <div class="title">《FASTGO快件赔付条款》</div>
          理赔启动条件：<br>
          1.丢失/破损包裹请于本人签收后 <span class="important">72小时</span>内填写售后理赔，他人签收<span class="important">7个自然日</span>内填写售后理赔，（顺丰本人签收<span class="important">24小时</span>他人签收 <span class="important">72小时</span>），逾期的申请因关联协议受限，我司将不予受理；<br>
          2.<span class="important">时效赔偿</span>，包裹清关后<span class="important">1个月内</span>未签收的包裹;<br>
          &nbsp;&nbsp;&nbsp;&nbsp;2.1此时效不包括不可控外因导致的揽收投递延误，如两会管制、疫情管制、洪涝灾害、双十一爆仓，春节货运管制等。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;2.2不包括因收件信息不准确、电话无法接通、要求变更收件信息等原因导致包裹延时或丢损。<br>
          3.破损包裹。客户收到包裹请务必立刻开箱确认内件是否完好！！！一旦发现破损，需要妥善保管原始货物状态（含纸箱）同时拍照留存，并提供破损物品的照片，含有清晰运单的外包装的图片。如果包裹<span class="important">外包装明显破损/污染/外包装变形（外箱虽无明显破损，但有被撞皱褶痕迹）</span>，则需要联系派件公司开具的破损、变形或者少件证明；<span class="important">不能开具证明写“外包装完好”</span>。外包装完好将无法申请理赔。<br>
          4.内件短少，需要提供收件包裹的签收时的重量，内件照片以及含有清晰外包装的照片，特别是封口胶带细节（有无二次封箱痕迹）。<br>
          理赔流程：<br>
          1.理赔申请请通过FASTGO公众号，选择“售后服务-售后理赔”，或者可以直接联系客服进行填写；<br>
          2.无论是否符合理赔要求客服都将在48小时内给与答复（通过短信/电话/微信），如果符合理赔启动条件则客服将同客户确认理赔的方式和金额。<br>
          3.符合条件的理赔，一般5-10个工作日完成赔付。<br>
          <table  border="1" cellpadding="0" cellspacing="0" width="100%">
            <tr >
              <th style="width: 140px">理赔项目</th>
              <th style="width: 300px">赔付金额（最高A$200)</th>
              <th>理赔条款</th>
            </tr>
            <tr>
              <td>包裹丢失</td>
              <td>按照商品价格（1）赔付</td>
              <td>条款：（2）（3）（4）（11）</td>
            </tr>
            <tr>
              <td>内件短少</td>
              <td>按照商品价格（1）赔付</td>
              <td>条款：（2）（5）（6）（11）</td>
            </tr>
            <tr>
              <td>内件破损</td>
              <td>符和包装标准 按照商品价格（1）*100%  <br>   不符和包装标准 按照商品价格（1）*50%</td>
              <td>条款：（2）（6）（7）（8）（9）（10）（11）</td>
            </tr>
          </table>
          备注 :*理赔的金额直接从后续运费中抵扣，内件破损和短少只按照商品价格赔付不含运费。<br>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;*包装标准：液体物品/胶囊保健品 封口处是否宽胶带等密封和加固，儿童奶粉/成人奶粉封口处应使用胶带加固，易碎品应使用气泡袋或者气柱袋保护。<br>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="important">*特别注意：包裹包装内件需有填充物，不能裸包装，裸包装的破损视为封装不妥，不予赔付。</span><br>
          理赔条款：<br>
          (1) 商品价格的定义：参考实际购买的小票，或者澳洲市场价格，非订单价格。如果客户寄件订单填写的物品信息不够详细或者商品信息错误，我公司有权则不予赔付。<br>
          (2) 包裹出库后客户要求修改收件地址，导致出现破损/丢件/短少，不予赔付。<br>
          (3) 因客观原因造成的时效延误，譬如海关查验，退运重新报关等，不予理赔。<br>
          (4) 因客户提供错误的商品信息/虚报/漏报/收件人信息不实/包裹价值超过A$200/而造成包裹被海关扣留，或者含有违禁物品包裹被销毁，不予理赔。<br>
          (5) 外包装箱完好，无开拆痕迹和二次封印痕迹的内件短少，整箱重量在运输过程中相同时，不予理赔。<br>
          (6) 外包装箱完好，海关开拆查验造成的破损不予理赔；海关查验件，不符合海关申报标准的，被直接销毁件不予理赔。<br>
          (7) 由于天气或者压力差原因导致的货品变形、融化、爆罐将不予赔偿，对于包装内固体货物受外力影响下的变形（如由于气压差成粉末状，改变其原始形状）不予理赔。如：<span class="important">Natural`s way 全系列软糖融化，Bio island全系列瓶子形变、内部融化，巧克力等相关产品融化，黑糖的爆罐以及胶囊类产品融化、粘连，口红断裂，外包装完好瓶内胶囊爆破，零食类产品因飞机气压造成爆破。</span><br>
          (8) 小安素以及类似小安素的铁皮封口奶粉（如Ensure奶粉和糖尿病奶粉），需要用气柱包装，否则不予理赔。<br>
          (9) 外箱没有破损，物品加固后出现因瓶身破损的液体外漏，从而导致包裹被污染，被污染的商品不予理赔。<br>
          (10) 请妥善加固包装液体、玻璃包装产品，如铁元、小黄瓜水、摩洛哥油、止咳水、黑糖、Jurlique、伊索、洗洁精、食用油、酵素以及瓷器等易爆易破产品。此类产品，如有破损，不予理赔<br>
          (11) 个人行李，因为是二手物品，请购买保险，保险按照价值的2%收取，没有购买保险出现的丢失，破损，不予赔付。<br>

        </div>
        <div class="carrier">
          <div class="title">《FASTGO快件禁运物品》</div>
          快递包装指南 <br>
          1.快递包裹可由客户打包、代收点打包等。客户打包可以选择自行打包，也可也到我司现场打包(需收取相应包装费)。<br>
          2.请勿在一个包装箱里装入过多的物品。<br>
          3.如果不是我司包装的货物，发件人需要对自己的包装负责。<br>
          4.蜂蜜，由于蜂蜜密度比较高，塑料包装不是很结实，应选择气柱袋等材料包装。<br>
          5.奶粉，应选用气柱袋或者气泡袋、塑料泡沫等内包装。<br>
          6.玻璃瓶、塑料瓶等易碎物品，应采用气柱袋等内包装。<br>
          7.液体、乳状物品，必须使用良好的包装材料进行包装，以避免该货物破损之后污染其它物品。<br>
          8.请用厚实的纸箱进行包装，如果箱子和托运物品间有空隙，请加入适当的填充物品，诸如塑料泡沫、气泡袋、气泡膜等。<br>
          9.因报纸可能涉及因文化差异导致的其他不可控因素，我们不建议在包装内填充报纸。<br><br>
          详细包装标准：<br>
          请咨询我司工作人员。<br>
          中华人民共和国禁止携带、邮寄进境的动植物及其产品名录 <br>
          <a href="http://www.gov.cn/zwgk/2012-03/02/content_2081510.htm" target="_blank" style="color:red;text-decoration: underline">http://www.gov.cn/zwgk/2012-03/02/content_2081510.htm</a>
        </div>
        <!--<div class="carrier">-->
          <!--<div class="title">《FASTGO快件打包规则》</div>-->
          <!--澳大利亚到中国 快件包裹打包规定 <br>-->
          <!--<table border="1" cellpadding="0" cellspacing="0" width="570px">-->
            <!--<tr>-->
              <!--<th style="width: 150px">商品类别</th>-->
              <!--<th>打包规则 <span class="important">包裹总价值低于$200</span></th>-->
              <!--<th>备注：请参考官方原价值打包。<span class="important">特价打折产品海关一般不予认可哦</span></th>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td rowspan="2">婴儿奶粉/特殊配方奶粉</td>-->
              <!--<td rowspan="2">数量≤3罐（4罐可发，联系询价）</td>-->
              <!--<td>3罐及以上奶粉不能混其他物品</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>1罐可混装5个保健品，2罐可混装3个保健品。称重计费</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>成人奶粉</td>-->
              <!--<td>数量≦8 袋（羊奶粉及蓝胖子奶粉，只能数量≦6</td>-->
              <!--<td>6袋/8袋成人奶粉不能混其他物品</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>低价食品</td>-->
              <!--<td>数量≦15 个</td>-->
              <!--<td>巧克力，米粉等普通食品（<span class="important">肉泥，罐头，乳酪，酸奶类，种子类不可以发</span>）</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>保健品</td>-->
              <!--<td>数量≦10 个</td>-->
              <!--<td>排油丸，花青素≦2（<span class="important">传销品牌不可发</span>）</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>低价洗护日用品</td>-->
              <!--<td>数量≦12个</td>-->
              <!--<td>肥皂，绵羊油洗护，单价≦$3/个</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>洗护用品（非奢侈品牌）</td>-->
              <!--<td>数量≦8 个</td>-->
              <!--<td>建议单价≦$6/个</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td rowspan="2">护肤品（非奢侈品牌</td>-->
              <!--<td rowspan="2">数量≦6 个</td>-->
              <!--<td>高于50AUD小于100AUD的 可以发2个</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>低于50AUD的可以发4-6个</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td colspan="3" style="text-align: left">备注：50 澳币以上的护肤品（雅诗兰黛，香奈儿, 兰蔻，SKII，AESOP， 娇韵诗，茱莉蔻等国际知名品牌）包装标准限 1个包裹1个</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td colspan="3" style="text-align: left"><span class="important">知名品牌护肤品套装/化妆品套装不能发，含濒危灭绝生物成分的物品不可以发，例如鲟鱼子， 鱼子酱，羊胎素成分等护肤品。</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>护肤品套装（非奢侈品牌）</td>-->
              <!--<td>数量≦1个</td>-->
              <!--<td>建议包裹总价值不超过50AUD，低价SUKIN三件套最多2套，价值大于50澳币护肤品套装，重量计费+价值20%的税</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>化妆品（非奢侈品牌）</td>-->
              <!--<td>数量≦3个</td>-->
              <!--<td>指眼影，粉底，口红等单价低于$50，高于50AUD的一个包裹1个</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>玩偶/玩具</td>-->
              <!--<td>数量≦3个</td>-->
              <!--<td>物品总价值低于$50</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>玩具积木（长宽高超过40cm有体积重）</td>-->
              <!--<td>数量≦1个</td>-->
              <!--<td>价值50AUD以下，按杂货重量计费。价值<span class="important">50-100AUD</span>，重量计费<span class="important">+10AUD</span>税费。价值大于<span class="important">100-200AUD</span>，重量计费<span class="important">+15AUD</span>税费</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td  rowspan="3">香水</td>-->
              <!--<td  rowspan="3">数量≦1个</td>-->
              <!--<td>价值低于40AUD，免税按杂货重量计费</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>价值<span class="important">40-120AU</span>，重量计费+税金<span class="important">15AUD</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>价值大于<span class="important">120AUD以上不收</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td  rowspan="3">首饰</td>-->
              <!--<td  rowspan="3">数量≦1个</td>-->
              <!--<td>低于50澳币的杂货计费</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>价值<span class="important">50-100AUD</span>，杂货重量计费<span class="important">+10AUD税费</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>价值大于<span class="important">100-200AUD</span>，杂货重量计费<span class="important">+15AUD税费</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>手表</td>-->
              <!--<td>数量≦1个</td>-->
              <!--<td>低于50澳币的杂货计费, <span class="important">大于50AUD-200AUD</span>，杂货计费+<span class="important">发票 *15%</span>的税费</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>包包</td>-->
              <!--<td>数量≦1个</td>-->
              <!--<td>低于50AUD杂货重量计费 价值<span class="important">50-100AUD</span>，重量计费<span class="important">+10AUD</span>税费；<span class="important">大于100AUD-200AUD</span>，杂货重量计费+<span class="important">发票15%计税</span>。</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td  rowspan="3">家用小电器</td>-->
              <!--<td  rowspan="3">数量≦1个</td>-->
              <!--<td>低于50AUD的杂货计费</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>价值<span class="important">50-100AUD</span>，杂货重量计费<span class="important">+10AUD税费</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>价值<span class="important">大于100-200AUD</span>，杂货重量计费<span class="important">+15 AUD税费</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td  rowspan="2">电动牙刷</td>-->
              <!--<td  rowspan="2">数量≦1个</td>-->
              <!--<td>成人电动牙刷1个包裹1个</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>儿童电动牙刷可 2 个1个包裹</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td  rowspan="3">鞋子（品牌、型号、货号、价值）</td>-->
              <!--<td  rowspan="3">数量≦1个</td>-->
              <!--<td><span class="important">普通帆布鞋，豆豆鞋，运动鞋类50AUD以内杂货计费</span>，大于250-400RMB 的重量计费+税<span class="important">10AUD</span>，400RMB以上重量计费+<span class="important">价值*20%</span>的税费</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td><span class="important">靴类40AUD以内杂货计费</span>，大于200-400RMB，重量计费+税<span class="important">15AUD</span>，400RMB以上，重量计费+<span class="important">价值*20%的</span>税费</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td><span class="important">鞋子折扣价低于以上打包要求无税价值的，关口查验后有产生税金的需客户自理</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td  rowspan="3">单薄衣服/帽子/围巾</td>-->
              <!--<td  rowspan="3">数量≦3个（限包裹总价值50澳币）</td>-->
              <!--<td>3件内总价值不超50AUD，按杂货重量计费</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>一件价值<span class="important">50-100AUD</span>之间，一个包裹一件，<span class="important">杂货重量计费+10AUD税费</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>一件价值<span class="important">大于100-200AUD</span>之间，一个包裹一件<span class="important">杂货重量计费+15AUD税费</span>。</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td  rowspan="3">被子/生活用品<span class="important">可塞进六罐箱</span>。</td>-->
              <!--<td  rowspan="3">数量≦1个</td>-->
              <!--<td>价值低于50AUD，按杂货重量计费；</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>一件价值<span class="important">50-100AUD</span>之间，一个包裹一件，杂货重量计费+10AUD税费。</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td>一件价值<span class="important">大于100-200AUD</span>之间，一个包裹一件<span class="important">杂货重量计费+15AUD税费。</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td colspan="3" class="text-center">被子，一个包裹一件。可塞进六罐箱，按实际重量计费；<span class="important">如果塞不进六罐箱，按体积重计费</span>。长*宽*高/5000 单位cm</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td colspan="3" class="text-center">杂货包裹重量不超过  3.5KG <span class="important">包裹价值低于$200</span></td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td colspan="3">混装  打包规则</td>-->
            <!--</tr>-->
            <!--<tr style="height: 80px">-->
              <!--<td  >保健品/食品混装</td>-->
              <!--<td  colspan="2">数量≦10个</td>-->
            <!--</tr>-->
            <!--<tr style="height: 80px">-->
              <!--<td >保健品/洗护日用品混装</td>-->
              <!--<td  colspan="2">数量≦8个</td>-->
            <!--</tr>-->
            <!--<tr style="height: 80px">-->
              <!--<td >保健品/护肤品</td>-->
              <!--<td  colspan="2">数量≦6个</td>-->
            <!--</tr>-->
            <!--<tr style="height: 80px">-->
              <!--<td >保健品/化妆品</td>-->
              <!--<td  colspan="2">数量≦4个</td>-->
            <!--</tr>-->
            <!--<tr style="height: 80px">-->
              <!--<td >化妆品/护肤品</td>-->
              <!--<td  colspan="2">数量≦4个</td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td colspan="3" class="text-center">杂货包裹重量不超过 3.5kg <span class="important">包裹价值低于$200</span> </td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td colspan="3" class="text-center">**不在打包规则上的特殊商品请咨询 FASTGO 客服或者财务 </td>-->
            <!--</tr>-->
            <!--<tr>-->
              <!--<td colspan="3" >-->
                <!--<span class="important">为了包裹能更好更快的完成清关，请务必提供上传有效收件人身份证正反面图片，包裹内件请填写真实内件的 品牌 规格和型号货号数量哦</span>。避免因查验申报不符造成的清关延误以及额外的税金等（需客户承担）。-->
                <!--护肤（化妆）品，衣服 ，鞋子，包包，饰品，玩具类。请务必保留当时购物价值小票上传客户群，便于关口核价和理赔。一般需提供真实有效的购买凭证小票或关口认可的网上截图（带网址的图片）或者链接 （链接需可有效查询到。如果特价打折没了关口税金参考原价！！！<span class="important">一般建议不发这种特价打折的或者经过客户允许我们可以尝试安排发走，被查验到税金由客户承担哦</span>。）-->
              <!--</td>-->
            <!--</tr>-->
          <!--</table>-->
          <!--<div class="other">-->
            <!--<div class="other-title">其他注意事项：</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div class="item-title">□ 禁运物品:</div>-->
              <!--<div class="item-content">易燃易爆航空管制品，肉制品，生鲜，干货，旧物品，液态奶，奶酪芝士，鸡蛋制品， 猫狗粮，烟草、处方药（胃药、银杏片），加工的种子制品（生咖啡豆，奇亚籽，麦麸，藜麦，薰衣草小熊等)，未加工的动物皮毛，证书文件，合同，光盘，文物，钞票硬币，等。</div>-->
            <!--</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div class="item-title">□ 运单填写:</div>-->
              <!--<div class="item-content">为了保证清关和赔偿效率，请如实填写物品的商品名称 和规格   （重量，粒数和容量）</div>-->
            <!--</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div class="item-title">□ 赔付:</div>-->
              <!--<div class="item-content">符合打包规范的包裹（不含特殊物品），赔偿总价不高于$200。客户有责任对包裹内件进行如实申报，如包裹内件不符合本规定，或物品包装以及保护方式不符合规定， 则我公司不予赔偿，因此产生的破损，丢失，税金，海关罚款以及其他衍生费用均由发货人承担。</div>-->
            <!--</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div class="item-title">□ 打包规范:</div>-->
              <!--<div class="item-content" style="font-weight: bolder">所有包裹内件请尽量用泡泡纸保护，务必确保包裹内空隙被填充满。</div>-->
            <!--</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div class="item-title">□ 特殊物品:</div>-->
              <!--<div class="item-content" style="font-weight: bolder">S26 婴儿奶粉，雅培系列糖尿病奶粉，孕妇奶粉，大小安素，袋装成人奶粉，蓝胖子奶粉，包装材料为玻璃瓶的商品，所有液体产品和洗护类产品，口红，因气温变化容易损坏的商品 请妥善包装，如有破损，不予赔偿。</div>-->
            <!--</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div class="item-title">□ 化妆品特指:</div>-->
              <!--<div class="item-content">口红，眼影，粉底 等彩妆类物品，不能邮寄彩妆礼盒（含彩妆赠品礼盒）。</div>-->
            <!--</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div style="text-align: left">□ 护肤品/保健品 套装 按照内件数量计算，并且需要填写包裹内件名称。</div>-->
            <!--</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div style="text-align: left">□ 发往香港、台湾、澳门的包裹<span class="important">不接受液体，粉末，和带有电池的小家电</span>。</div>-->
            <!--</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div style="text-align: left">□ 8袋 A2/德运成人奶粉发货羊奶粉及蓝胖子奶粉除外），新疆、西藏、青海，港澳台地区暂时不收。</div>-->
            <!--</div>-->
            <!--<div class="other-item clearfix">-->
              <!--<div style="text-align: left">□ 泡重物品按照能够放入一个 6 罐箱为准，体积重量按照长宽高边长有一边超过40cm ，按照体积重量计费收取。</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "serviceAgreement",
    methods:{
      closeContainer() {
          this.$store.commit('setServiceAgreement',false)
      }

    }
  }
</script>

<style scoped>
  .wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100000;
    background: rgba(0, 0, 0, 0.1);
  }
  .content{
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    margin: 50px auto;
    width: 600px;
    height: 80vh;
    background: #F8F8F8;
    overflow: hidden;
  }
  .container-title{
    width: 100%;
    background: #fff;
    height: 7%;
    line-height: 50px;
    color: #8E8E8E;
    text-align: center;
    position: relative;

  }
  .container-title-close{
    position: absolute;
    right: 10px;
    top: -1px;
    font-size: 26px;
    cursor: pointer;
  }
  .container{
    height: 90%;
    overflow-y: scroll;
    color: #8E8E8E;
    font-size: 14px;
    padding: 20px;
    line-height: 24px;
    padding-bottom: 20px;
    box-sizing: border-box;
  }
  /* 设置滚动条的样式 */
  ::-webkit-scrollbar {
    width: 8px;
    height: 5px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.3);
  }
  .important{
    color: red;

  }
  .title{
    text-align: center;
    color: #000;
    font-size: 16px;
    font-weight: bolder;
  }

</style>



// WEBPACK FOOTER //
// src/components/serviceAgreement.vue